import { defineStore } from "pinia";
import { ref } from "vue";
import type { GROUPING_SAVE_KEY } from "@/shared/list-filter/composables/grouping-settings.ts";

export const useGroupingStore = defineStore("grouping", () => {
    // undefined means that neither the saved preference nor the user has set a value yet
    const isGrouped = ref<Partial<Record<GROUPING_SAVE_KEY, boolean>>>({});

    function setIsGrouped(key: GROUPING_SAVE_KEY, value: boolean) {
        isGrouped.value[key] = value;
    }

    return {
        isGrouped,
        setIsGrouped,
    };
});
